import React from 'react';
import Kinyonga from './Kinyonga';

/**
 * Loading screen — shows the Mbegu company logo with a spinning ring.
 * Shown by React Suspense while lazy page chunks download.
 */
const LoadingScreen: React.FC = () => (
  <div
    className="fixed inset-0 flex flex-col items-center justify-center z-50"
    style={{ background: 'var(--paper, #F6F4ED)' }}
  >
    {/* Logo + animated ring */}
    <div className="relative flex items-center justify-center">
      {/* Outer spinning ring */}
      <div
        className="absolute"
        style={{
          width: 88, height: 88,
          borderRadius: '50%',
          border: '2px solid transparent',
          borderTopColor: '#2F9E5E',
          borderRightColor: '#13492F',
          animation: 'spin 1.2s linear infinite',
        }}
      />
      {/* Inner ring (counter-spin, lighter) */}
      <div
        className="absolute"
        style={{
          width: 72, height: 72,
          borderRadius: '50%',
          border: '1.5px solid transparent',
          borderBottomColor: '#2F9E5E',
          borderLeftColor: '#EAF3EC',
          animation: 'spin 2s linear infinite reverse',
        }}
      />
      {/* Kinyonga peeks out while chunks load */}
      <Kinyonga variant="head" size={56} />
    </div>

    {/* Text */}
    <p
      className="mt-5 text-xs tracking-[0.2em] uppercase"
      style={{ color: '#5C7367', fontFamily: "'IBM Plex Mono', monospace" }}
    >
      Kinyonga is checking on your seedlings…
    </p>
  </div>
);

export default LoadingScreen;
